<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-file-plus-outline</v-icon>
				自由記入
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">自由記入</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet class="pa-2" elevation="0">
				<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
					<tbody>
						<ShowDetailRecord
							:columnName="'対象カテゴリ'"
							:value="categoryName"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'品名'">
							<template v-slot:value
								><v-text-field
									v-model="TODO"
									background-color="white"
									:rules="[]"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'規格'">
							<template v-slot:value
								><v-text-field
									v-model="TODO"
									background-color="white"
									:rules="[]"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'仕様'">
							<template v-slot:value
								><v-text-field
									v-model="TODO"
									background-color="white"
									:rules="[]"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'単位'">
							<template v-slot:value
								><v-text-field
									v-model="TODO"
									background-color="white"
									:rules="[]"
									dense
									outlined
									hide-details
								/>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'数量'">
							<template v-slot:value
								><v-text-field
									v-model="TODO"
									background-color="white"
									:rules="[rules.float]"
									dense
									outlined
									type="number"
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
			<v-card-actions class="pa-2">
				<v-row no-gutters justify="center">
					<v-btn @click="submitForm" color="secondary">
						<v-icon class="mr-1">mdi-file-plus-outline</v-icon>
						追加する
					</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import dialogMixin from "../../../helper/dialogMixin"

export default {
	mixins: [dialogMixin("withBtn")],
	props: {
		category: {
			type: String,
			required: false,
			default: null,
		},
		categories: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			TODO: null,
			common,
			rules,
		}
	},
	methods: {
		submitForm() {
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					// TODO
					this.$emit("create-item", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		categoryName() {
			return this.categories.find((category) => category.id === this.category)?.name
		},
		itemsByCategory() {
			return this.items.filter((item) => item.category === this.category)
		},
	},
}
</script>